/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";

var SurveyListViewModel = function(params) {
	document.body.classList.add("birdata-fullscreen");

	var self = this;

	// Set default params
	params = _.defaults(params, {
		completed: true
	});

	self.surveys = ko.observableArray([]);
	self.message = ko.observable("Loading");
	self.title = params.completed ? "Surveys" : "Incomplete Surveys";
	self.showButton = !params.completed;

	var surveyParams = _.pick(params, 'completed');

	Promise.all([
		birdata.mySurveys(surveyParams),
		birdata.lookup('program')
	]).then(function([surveys, programs]) {
		self.message(null);

		_.each(data.surveys, function(survey) {
			survey.program = _.find(data.programs, function(p) { return p.code == survey.program; });

			survey.url = 'record-survey#id=' + survey.id + '&tab=review';
		});

		var surveys = _.sortBy(data.surveys, 'start_date').reverse();

		self.surveys(surveys);
	}).catch(function(error) {
		self.message(error.message);
	});
};


ko.components.register('survey-list', {
	viewModel: function(params) {
		return new SurveyListViewModel(params);
	},
	template: require('../../templates/survey-list.html')
});

export default SurveyListViewModel;
